import React, { useContext, useEffect, useState } from 'react'
import ProductComponent from '../AddProductComponent'
import { TabTitle } from '../../../../util/titleChanger'
import { GlobalState } from '../../../../GlobalState'
import { useParams } from 'react-router-dom'
import { createNewPurchase, updatePurchase } from '../../../../action'
import { ToastContainer, toast } from 'react-toastify'
import Loading from '../../../../util/Loading'

export default function PurchaseForm() {
    const { purchaseId } = useParams();
    TabTitle(purchaseId > 0 ? "Update Purchase" : "Add Purchase")
    const state = useContext(GlobalState);
    const signInUser = JSON.parse(localStorage.getItem('user_data'));

    //Import purchase state from global state below
    const [purchaseDetail] = state.purchaseAPI.purchaseDetail;
    const [id, setId] = state.purchaseAPI.id;
    const [callback, setCallback] = state.purchaseAPI.callback;

    //Import product state from global state below
    const [productDetail] = state.productAPI.productDetail;

    //Import supplier State from global state below
    const [allSuppliers] = state.supplierAPI.allSuppliers;

    //Local State
    const [btnName, setBtnName] = useState("Save")
    const [focused, setFocused] = useState(false)
    const [values, setValues] = useState([])

    //For auto complete state
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [selectSupplier, setSelectSupplier] = useState("")
    const suggestions = allSuppliers.filter(supplier =>
        supplier.first_name.toString().toLowerCase().includes(selectSupplier.toString().toLowerCase())
    )

    //Get value form input elements and assign into values states
    const onChangeValue = (e) => {
        e.preventDefault();
        setValues({ ...values, [e.target.name]: e.target.value })
    }

    const handleSuggestionClick = (suggestion) => {
        setSelectSupplier(suggestion.first_name + " " + suggestion.last_name)
        setShowSuggestions(false)
        setValues({
            ...values,
            supplierId: suggestion.id
        })
    }

    const onChangeSelectSupplier = (e) => {
        setSelectSupplier(e.target.value)
    }

    //Product Component Params
    const [productInput, setProductInput] = useState([])

    const handProductInputOnChange = (e, name, value, index) => {
        e.preventDefault();
        const list = [...productInput];
        list[index][name] = value;
        setProductInput(list);
    }

    const handleAddComponentClick = (e) => {
        e.preventDefault();
        setProductInput([
            ...productInput,
            {
                categoryId: "",
                productId: "",
                quantity: "",
                purchase_price: "",
                selling_price: ""
            }])
    }

    const handleRemoveComponentClick = (e, index) => {
        e.preventDefault();
        const list = [...productInput];
        list.splice(index, 1);
        setProductInput(list);
    }

    const handleFocus = (e) => {
        setFocused(true);
    }

    useEffect(() => {
        setProductInput([])
        if (purchaseId > 0) {
            setId(purchaseId);
            setBtnName('Update');
            var today = new Date();
            var purchase_date = new Date(purchaseDetail.purchase_date);

            setValues({
                invoice_no: purchaseDetail ? purchaseDetail.invoice_no : "",
                total_amount: purchaseDetail ? purchaseDetail.total_amount : "",
                quantity: purchaseDetail ? purchaseDetail.quantity : "",
                purchase_date: purchaseDetail.purchase_date === undefined ? today.toISOString().substring(0, 10) : purchase_date.toISOString().substring(0, 10),
                description: purchaseDetail ? purchaseDetail.description : "",
                supplierId: purchaseDetail.supplier ? purchaseDetail.supplier.id : "",
            })

            purchaseDetail.purchase_products ? purchaseDetail.purchase_products.map((product) => {
                setProductInput((products) => {
                    return [
                        ...products,
                        {
                            categoryId: product.product ? product.product.category.id : "",
                            productId: product.product ? product.product.id : "",
                            quantity: product.quantity ? product.quantity : 0,
                            purchase_price: product.purchase_price ? product.purchase_price : 0,
                            selling_price: product.selling_price ? product.selling_price : 0
                        }]
                })
            }) : setProductInput([])

            allSuppliers.map(supplier => {
                const supplier_id = purchaseDetail.supplier ? purchaseDetail.supplier.id : "1";
                if (supplier.id === supplier_id) {
                    setSelectSupplier(supplier.first_name + " " + supplier.last_name)
                }
            })
        }
    }, [allSuppliers, id, purchaseId, productDetail, purchaseDetail])

    const submitDefault = (e) => {
        e.preventDefault();

        var totalAmount = productInput.reduce((total, product) => {
            return total = total + (product.quantity * product.purchase_price)
        }, 0)

        var totalQuantity = productInput.reduce((total, product) => {
            return total = total + parseInt(product.quantity);
        }, 0)

        const productInfo = {
            invoice_no: values.invoice_no,
            total_amount: totalAmount,
            quantity: totalQuantity,
            purchase_date: values.purchase_date,
            description: values.description,
            supplierId: values.supplierId,
            updatedBy: signInUser.id,
            products: productInput
        }

        if (purchaseId > 0) {
            updatePurchase(purchaseId, productInfo, res => {
                if (res.status === 200) {
                    toast.success(res.data)
                    setCallback(!callback)
                } else if (res.status === 204) {
                    toast.info(res.data)
                    setCallback(!callback)
                } else {
                    toast.error(res.data)
                    setCallback(!callback)
                }
            })
        } else {
            productInfo.createdBy = signInUser.id
            createNewPurchase(productInfo, res => {
                if (res.status === 200) {
                    toast.success(res.data)
                    setCallback(!callback)
                } else {
                    toast.error(res.data)
                    setCallback(!callback)
                }
            })
        }

    }

    return (
        !Object.keys(purchaseDetail).length === 0 ? <div className="form-container"><div className="loading-page-container"><Loading /></div></div>
            : <div className="form-container" >
                <header>Purchase Form</header>
                <form onSubmit={submitDefault} className="form">

                    <div className="input-box">
                        <label htmlFor="invoice_no">Invoice No</label>
                        <input
                            type="text"
                            name="invoice_no"
                            id="invoice_no"
                            placeholder='Enter Invoice No'
                            value={values.invoice_no || ""}
                            required pattern='^(\w+\S+)$'
                            onBlur={handleFocus}
                            focused={focused.toString()}
                            onChange={onChangeValue}
                        />
                        <span>Invoice no required</span>
                    </div>

                    <div className="input-box">
                        <label htmlFor="supplierId">Supplier Name</label>
                        <input
                            type="text"
                            name="supplierId"
                            id="supplierId"
                            placeholder='Enter Supplier Name'
                            value={selectSupplier}
                            onBlur={handleFocus}
                            focused={focused.toString()}
                            onChange={onChangeSelectSupplier}
                            onFocus={() => setShowSuggestions(true)}
                        />
                        {
                            showSuggestions && (
                                <ul className="suggestions">
                                    {
                                        suggestions.map(suggestion => (
                                            <li key={suggestion.id} onClick={() => handleSuggestionClick(suggestion)}>
                                                {suggestion.first_name + "" + suggestion.last_name}
                                            </li>
                                        ))
                                    }
                                </ul>
                            )
                        }
                    </div>

                    <div className="input-box">
                        <label htmlFor="purchase_date">Purchase Date</label>
                        <input
                            type="date"
                            name="purchase_date"
                            id="purchase_date"
                            value={values.purchase_date || new Date().toISOString().substring(0, 10)}
                            onChange={onChangeValue}
                        />
                    </div>

                    <div className="input-box">
                        <label htmlFor="description">Description</label>
                        <textarea
                            name="description"
                            id="description"
                            cols="30" rows="5"
                            placeholder='Enter description here...'
                            onChange={onChangeValue}
                            value={values.description || ""}
                        />
                    </div>


                    <div className="input-box">
                        <div className='btn-separator'>
                            <div>
                                {
                                    productInput.map((products, index) => (
                                        <div key={index}>
                                            <ProductComponent
                                                handProductInputOnChange={handProductInputOnChange}
                                                index={index}
                                                handleRemoveComponentClick={handleRemoveComponentClick}
                                                products={products}
                                            />
                                        </div>
                                    ))
                                }

                            </div>
                            <div className='plus-btn'>
                                <button onClick={(e) => handleAddComponentClick(e)}><i className="uil uil-plus"></i></button>
                            </div>
                        </div>
                    </div>

                    <div className="form-button">
                        <button className="add_new">{btnName}</button>
                    </div>
                </form>

                <ToastContainer />
            </div >
    )
}
